function pad2(value: number): string {
	return String(value).padStart(2, "0")
}

export function isoToDateTimeLocalValue(iso: string | null): string {
	if (!iso) return ""
	const date = new Date(iso)
	if (Number.isNaN(date.getTime())) return ""
	return [
		date.getFullYear(),
		"-",
		pad2(date.getMonth() + 1),
		"-",
		pad2(date.getDate()),
		"T",
		pad2(date.getHours()),
		":",
		pad2(date.getMinutes()),
	].join("")
}

export function dateTimeLocalValueToIso(value: string): string | null {
	const trimmed = value.trim()
	if (!trimmed) return null
	const date = new Date(trimmed)
	if (Number.isNaN(date.getTime())) return null
	return date.toISOString()
}
